import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import List from '@jetbrains/ring-ui/components/list/list';
const PluginSourceLabels = {
    TBE: 'Corporate plugin repository',
    MARKETPLACE: 'Marketplace',
    BUNDLED: 'Bundled plugins'
};
export function formatPluginSourceName(pluginSource) {
    return PluginSourceLabels[pluginSource] || '';
}
export function toPluginSelectItem(plugin, renderSource = true) {
    const suffix = renderSource ? ` (${formatPluginSourceName(plugin.source)})` : '';
    return {
        ...plugin,
        rgItemType: List.ListProps.Type.CUSTOM,
        template: (_jsxs(_Fragment, { children: [_jsx("div", { children: plugin.label }), _jsx(Text, { info: true, children: plugin.key + suffix })] }))
    };
}
